export const PATHS = {
  // Default
  DEFAULT: "/",

  // Auth
  LOGIN: "/login",
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD: "reset-password",
  OTP_DETAILS: "/otp-details",
  OTP_VERIFICATION: "/otp-verification",

  // Dashboard Module
  DASHBOARD: "/dashboard",

  // User management
  USER: "/users",
  USER_LIST: "patients-list",
  ADMIN_USER: "admin-users",
  APP_USER: "app-users",
  PAGE_TITLE: "page-title",

  // Content management
  CONTENT: "/content",
  STATIC_PAGES: "static-pages",

  // Role
  ROLE: "/role",

  // Email And Notification
  EMAIL_TEMPLATES: "/email-templates",

  // Master management
  MASTER_MANAGEMENT: "/master",
  // Not Assess Reason
  NOT_ASSESS_REASON: "not_assess_reason",
  //MMaster
  TERRITORY: "territory",
  ETIOLOGY: "etiology",
  PROFESSIONAL_DESIGNATION: "professional-designation",

  //Wound Management
  WOUND_LISTING: "visit",
  WOUND_DETAILS: "wound",
  ASSESSMENT_DETAILS: "assessment",

  // Support
  SUPPORT: "/support",

  QUESTIONNARIE: "questionnaire",
  // Settings
  SETTINGS: "/settings",
  GENERAL_SETTINGS: "general-settings",

  SMTP_SMS_DETAILS: "smtp-details",
  EMAIL_NOTIFICATIONS: "email-notifications",

  // Common Pages
  FourZeroFour: "/common/404",
  THANKYOU: "/common/thankyou",
  COMING_SOON: "/common/coming-soon",

  // Profile
  MY_PROFILE: "/profile",
  EDIT_MY_PROFILE: "/profile/edit-profile",

  // Change Password
  CHANGE_PASSWORD: "/change-password",

  // Ui Kit
  UI_KIT: "/uikit",
  TYPOGRAPHY: "typography",
  COLORS: "colors",
  FORMS: "forms",
  CARDS: "cards",
  BLOCKS: "blocks",
  // Extras
  ANY: "*",
  VIEW: "view",
  CREATE: "create",
  EDIT: "edit",
  NOTIFICATIONS: "notifications",
};
